const stringHash = require('string-hash');

// Function constructor works for sharing with front-end and back-end,
// ES6 class doesn't without extra build work
function ShoppingListItem({ id, foodItemId = null, description, externalId }) {
  this.id = id;
  this.foodItemId = foodItemId;
  this.description = description;
  this.externalId = externalId;

  if (!description) {
    throw new Error('New shopping list item must have description');
  }

  if (!externalId) {
    let s = description;
    if (foodItemId) {
      s += foodItemId;
    }

    this.externalId = stringHash(s).toString();
  }
}

module.exports = ShoppingListItem;



// WEBPACK FOOTER //
// ./src/shared/ShoppingListItem.js